import { FC, PropsWithChildren, useMemo } from "react";
import clsx from "clsx";
import { ValidationWrapperProps } from "./types";
import styles from "./styles.scss";

export const ValidationWrapper: FC<
  PropsWithChildren<ValidationWrapperProps>
> = ({ children, errorMessage, helperMessage, successMessage }) => {
  const messageClass = useMemo(() => {
    if (errorMessage) {
      return styles.error;
    }

    if (successMessage) {
      return styles.success;
    }

    if (helperMessage) {
      return styles.helper;
    }

    return null;
  }, [errorMessage, helperMessage, successMessage]);

  return (
    <div className={messageClass ? styles.container : styles.containerSimple}>
      <div className={clsx(styles.input, messageClass)}>{children}</div>
      {messageClass && (
        <span className={clsx(styles.message, messageClass)}>
          {errorMessage || successMessage || helperMessage}
        </span>
      )}
    </div>
  );
};
